const { isLoggedIn } = useAuth()
const currentUser = ref<UserAuthResponse | undefined>()
const setUser = (user: UserAuthResponse) => {
  currentUser.value = user
  hasLoaded.value = true
}

const hasLoaded = ref(false)
const isLoading = ref(false)
const retrieveSelf = async () => {
  if (isLoading.value) return
  isLoading.value = true
  try {
    const user = await retrieveSelfUser()
    setUser(user)
  } finally {
    isLoading.value = false
  }
}

export const useCurrentUser = () => {
  whenever(
    () => isLoggedIn.value && !hasLoaded.value,
    () => {
      retrieveSelf()
    },
    {
      immediate: true,
    }
  )

  return {
    currentUser: readonly(currentUser),
    setUser,
    retrieveSelf,
  }
}
